import { SITE } from "@/lib/constants";
import { MessageCircle } from "lucide-react";

export function WhatsAppFab() {
  const href = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(
    "Hi Nicee! I'd like to know more about your products."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lift transition-transform duration-300 hover:-translate-y-1"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
}
